<template>
    <v-container id="notificadeuda">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>NOTIFICACIONES DE DEUDA DE MATRICULADOS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="actualizagrillanotificaciones"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Nueva Notificación"
                    @click="nueva"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card>
                    <v-card-title>
                      <v-text-field
                        v-model="notificabusca"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-data-table
                      :headers="columnas"
                      :items="lista"
                      :items-per-page="10"
                      :footer-props="{
                          'items-per-page-text': 'Filas por Página:',
                          'items-per-page-all-text': 'Todos',
                      }"
                      item-key="idnotificacion"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros"
                      multi-sort
                      :search="notificabusca"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              icon
                              color="blue"
                              @click="editar(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!permisoescritura || !item.permitemodificar"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        &nbsp;
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              icon
                              color="green"
                              @click="enviar(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!permisoescritura || !item.permiteenviar"
                            >
                              <v-icon>mdi-send</v-icon>
                            </v-btn>
                          </template>
                          <span>Activar Envío</span>
                        </v-tooltip>
                        &nbsp;
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              icon
                              color="red"
                              @click="anular(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!permisoescritura || !item.permiteanular"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Anular</span>
                        </v-tooltip>
                        &nbsp;
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              icon
                              color="#fda83c"
                              @click="verdestinatarios(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!permisolectura || item.idestado===3 || item.idestado===4 || item.idestado===5"
                            >
                              <v-icon>mdi-account-group</v-icon>
                            </v-btn>
                          </template>
                          <span>Ver Destinatarios</span>
                        </v-tooltip>
                        &nbsp;
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              icon
                              color="#aa46f5"
                              @click="verenvios(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!permisolectura || item.idestado===1 || item.idestado===2 || item.idestado===3 || item.idestado===5"
                            >
                              <v-icon>mdi-invoice-text-send</v-icon>
                            </v-btn>
                          </template>
                          <span>Ver Envíos</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:item.estado="{ item }">
                        <v-chip :color="getColorConsulta(item.idestado)" dark>
                          <p class="textofilagrilla">{{ item.estado }}</p>
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialognuevo" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialognuevotitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardar">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevo = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  v-model="menufechaenvio"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechaenviolocal"
                      label="Fecha Envío"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="edited.fechaenvio"
                    @input="menufechaenvio = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  ref="menuhoraenvio"
                  v-model="menuhoraenvio"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="edited.horaenvio"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="edited.horaenvio"
                      label="Hora Envío"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                      class="ocupa95"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuhoraenvio"
                    v-model="edited.horaenvio"
                    full-width
                    @click:minute="$refs.menuhoraenvio.save(edited.horaenvio)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-select
                  v-model="edited.nronotificacion"
                  :items="listanrosnotificacion"
                  label="N° Notificación"
                  item-text="nronotificacion"
                  item-value="nronotificacion"
                  height="20px"
                  :disabled="edited.listadestinatarios.length>0"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="edited.titulo"
                  label="Título Notificación"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  v-model="menufechadeuda"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechadeudalocal"
                      label="Fecha Deuda"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                      :disabled= "edited.listadestinatarios.length>0"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="edited.fechadeuda"
                    @input="menufechadeuda = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <br />
            <br />
            <v-row row wrap>
              <v-col cols="12" md="4" lg="4">
                <p class="TituloGrilla">Destinatarios</p>
              </v-col>
              <v-col cols="12" md="8" lg="8">
                <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Modificar Destinatarios"
                    @click="modificardestinatarios"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    x-small
                    color="red"
                    title="Eliminar Todos los Destinatarios"
                    @click="eliminardestinatarios"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-delete</v-icon>
                  </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" >
                <v-data-table
                    :headers="columnasdestinatarios"
                    :items="edited.listadestinatarios"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idpersona"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Destinatarios"
                    multi-sort
                  >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          color="red"
                          @click="quitardestinatario(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Quitar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogverdestinatarios" max-width="1200">
        <v-card>
          <v-card-title class="headline">
            Destinatarios de la Notificación ID {{ edited.idnotificacion }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogverdestinatarios = false"
                >
                    Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" >
                <v-card>
                  <v-card-title>
                    <v-text-field
                      v-model="personadestinatarioverbusca"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                      :headers="columnasdestinatariosver"
                      :items="edited.listadestinatarios"
                      :items-per-page="10"
                      :footer-props="{
                          'items-per-page-text': 'Filas por Página:',
                          'items-per-page-all-text': 'Todos',
                      }"
                      item-key="idpersona"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Destinatarios"
                      multi-sort
                      :search="personadestinatarioverbusca"
                    >
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogverenvios" max-width="1200">
        <v-card>
          <v-card-title class="headline">
            {{ dialogverenviostitulo }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogverenvios = false"
                >
                    Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" >
                <v-card>
                  <v-card-title>
                    <v-text-field
                      v-model="personaenviobusca"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                      :headers="columnasenvios"
                      :items="listaenviosnotificacion"
                      :items-per-page="10"
                      :footer-props="{
                          'items-per-page-text': 'Filas por Página:',
                          'items-per-page-all-text': 'Todos',
                      }"
                      item-key="idenvio"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros de Envíos"
                      multi-sort
                      :search="personaenviobusca"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              icon
                              color="blue"
                              @click="descargarpdfenvio(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="item.urlwebpdfcorreo.length===0"
                            >
                              <v-icon>mdi-printer</v-icon>
                            </v-btn>
                          </template>
                          <span>Descargar Envio</span>
                        </v-tooltip>
                      </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogselectdestinatarios" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Selecciona los Destinatarios de la Notificación
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="seleccionardestinatarios">
                    Seleccionar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogselectdestinatarios = false"
                >
                    Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar Deudores"
                  @click="listarpersonasdestinatarios"
                  :disabled="!permisolectura"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-card>
                  <v-card-title>
                    <v-text-field
                      v-model="personadestinatariobusca"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                      v-model="edited.listadestinatarios"
                      :headers="columnaspersonasdest"
                      :items="listapersonasdest"
                      :items-per-page="1000"
                      :footer-props="{
                          'items-per-page-text': 'Filas por Página:',
                          'items-per-page-all-text': 'Todos',
                      }"
                      show-select
                      item-key="idpersona"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros"
                      multi-sort
                      :search="personadestinatariobusca"
                    >
                    <template v-slot:item.obsselectable="{ item }">
                        <v-chip v-if="item.obsselectable.length>0" color="red" dark>
                          <p class="textofilagrilla">{{ item.obsselectable }}</p>
                        </v-chip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "notificadeuda",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 62,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      columnas: [
        {
            text: "Op.",
            value: "actions",
            width: 130
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idnotificacion",
            width: 30
        },
        {
            text: "Tipo",
            align: "center",
            sortable: true,
            value: "tiponotificacion",
            width: 80
        },
        {
            text: "F. Carga",
            align: "center",
            sortable: true,
            value: "fechacargastrdmy",
            width: 80
        },
        {
            text: "N° Notif.",
            align: "center",
            sortable: true,
            value: "nronotificacion",
            width: 90
        },
        {
            text: "Título",
            align: "center",
            sortable: true,
            value: "tituloenvio",
            width: 110
        },
        {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estado",
            width: 100
        },
        {
            text: "F. Envío Prev.",
            align: "center",
            sortable: true,
            value: "fechahoraenviostrdmy",
            width: 120
        },
        {
            text: "Usuario",
            align: "center",
            sortable: true,
            value: "usuario",
            width: 100
        }
      ],
      lista: [],
      menufechaenvio: false,
      menuhoraenvio: false,
      edited: {
        idnotificacion: 0, 
        fechaenvio: '',
        horaenvio: '',
        listadestinatarios: [],
        nronotificacion: 1,
        fechadeuda: '',
        titulo: '',
        usuario: ''
      },
      dialognuevo: false,
      columnasdestinatarios: [
        {
            text: "Op.",
            value: "actions",
            width: 120
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idpersona",
            width: 30
        },
        {
            text: "N° Mat",
            align: "center",
            sortable: true,
            value: "nromatricula",
            width: 50
        },
        {
            text: "Apellidos",
            align: "center",
            sortable: true,
            value: "apellidos",
            width: 110
        },
        {
            text: "Nombres",
            align: "center",
            sortable: true,
            value: "nombres",
            width: 140
        },
        {
            text: "DNI",
            align: "center",
            sortable: true,
            value: "nrodoc",
            width: 80
        },
        {
            text: "Correos",
            align: "center",
            sortable: true,
            value: "correos",
            width: 200
        },
        {
            text: "Deuda",
            align: "center",
            sortable: true,
            value: "saldo",
            width: 100
        }
      ],
      columnasdestinatariosver: [
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idpersona",
            width: 30
        },
        {
            text: "N° Mat",
            align: "center",
            sortable: true,
            value: "nromatricula",
            width: 50
        },
        {
            text: "Apellidos",
            align: "center",
            sortable: true,
            value: "apellidos",
            width: 110
        },
        {
            text: "Nombres",
            align: "center",
            sortable: true,
            value: "nombres",
            width: 140
        },
        {
            text: "DNI",
            align: "center",
            sortable: true,
            value: "nrodoc",
            width: 80
        },
        {
            text: "Correos",
            align: "center",
            sortable: true,
            value: "correos",
            width: 200
        },
        {
            text: "Deuda",
            align: "center",
            sortable: true,
            value: "saldo",
            width: 100
        }
      ],
      dialogselectdestinatarios: false,
      columnaspersonasdest: [
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idpersona",
            width: 30
        },
        {
            text: "Obs.",
            align: "center",
            sortable: true,
            value: "obsselectable",
            width: 100
        },
        {
            text: "N° Mat",
            align: "center",
            sortable: true,
            value: "nromatricula",
            width: 90
        },
        {
            text: "Apellidos",
            align: "center",
            sortable: true,
            value: "apellidos",
            width: 110
        },
        {
            text: "Nombres",
            align: "center",
            sortable: true,
            value: "nombres",
            width: 140
        },
        {
            text: "DNI",
            align: "center",
            sortable: true,
            value: "nrodoc",
            width: 80
        },
        {
            text: "Correos",
            align: "center",
            sortable: true,
            value: "correos",
            width: 200
        },
        {
            text: "Deuda",
            align: "center",
            sortable: true,
            value: "saldo",
            width: 100
        }
      ],
      listapersonasdest: [],
      listanrosnotificacion: [{nronotificacion: 1},{nronotificacion: 2}],
      menufechadeuda: false,
      dialogverdestinatarios: false,
      dialogverenvios: false,
      dialogverenviostitulo: '',
      columnasenvios: [
        {
            text: "Op.",
            value: "actions",
            width: 70
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idenvio",
            width: 30
        },
        {
            text: "Destinatario",
            align: "center",
            sortable: true,
            value: "persona",
            width: 150
        },
        {
            text: "Correo",
            align: "center",
            sortable: true,
            value: "correoelectronico",
            width: 150
        },
        {
            text: "F. Envío",
            align: "center",
            sortable: true,
            value: "fechahoraenvio",
            width: 100
        },
        {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estadoenvio",
            width: 120
        },
        {
            text: "F. Estado",
            align: "center",
            sortable: true,
            value: "fechahoraestado",
            width: 100
        },
        {
            text: "Obs.",
            align: "center",
            sortable: true,
            value: "obsestado",
            width: 100
        }
      ],
      listaenviosnotificacion: [],
      personadestinatariobusca: '',
      personadestinatarioverbusca: '',
      personaenviobusca: '',
      notificabusca: ''
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var roles= localStorage.getItem('rolesusuario')
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion===1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
      this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
      this.actualizagrillanotificaciones();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    actualizagrillanotificaciones () {
      this.loading=true;
      var filtro= JSON.stringify({anio: 0, mes: 0, idtipo: 0, nronotificacion: 0});
      axios.post("Notificacion/PostListaNotificaciones", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.lista = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    nueva () {
      this.dialognuevotitulo= 'Nueva Notificación';
      this.edited= {
        idnotificacion: 0, 
        fechaenvio: this.fechaFormatoymd(new Date()),
        horaenvio: this.horaFormatoymd(new Date()),
        listadestinatarios: [],
        nronotificacion: 1,
        fechadeuda: this.fechaFormatoymd(new Date()),
        titulo: 'NOTIFICACIÓN DE DEUDA',
        usuario: this.usuario
      };
      this.dialognuevo=true;
    },
    editar (item) {
      this.loading=true;
      this.dialognuevotitulo= 'Editando Notificación ID ' + item.idnotificacion;
      var filtro= JSON.stringify({ idnotificacion: item.idnotificacion, usuario: this.usuario });
      axios.post("Notificacion/PostDestinatariosNotificacion", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.edited= {
            idnotificacion: item.idnotificacion, 
            fechaenvio: item.fechaenviostrymd,
            horaenvio: item.horaenviostrymd,
            listadestinatarios: result.data.datos,
            nronotificacion: item.nronotificacion,
            fechadeuda: item.fechadeudastrymd,
            titulo: item.tituloenvio,
            usuario: this.usuario
          };
          this.dialognuevo=true;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    guardar () {
      var valido='';
      if(this.edited.fechaenvio===null || this.edited.fechaenvio.length===0) {
        valido= 'Debe ingresar fecha de envío';
      }
      if(this.edited.horaenvio===null || this.edited.horaenvio.length===0) {
        valido= 'Debe ingresar hora de envío';
      }
      if(this.edited.listadestinatarios.length===0) {
        valido= 'Debe seleccionar destinatarios para la notificación';
      }
      if(this.edited.fechadeuda===null || this.edited.fechadeuda.length===0) {
        valido= 'Debe seleccionar la fecha de c´lculo de deuda';
      }
      if(this.edited.titulo===null || this.edited.titulo.length===0) {
        valido= 'Debe ingresar el título del correo de notificación';
      }

      if(valido.length===0) {
        this.loading= true;
        const notificacion = JSON.stringify(this.edited);
        axios.post("notificacion/PostGuardarNotificacion", notificacion, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevo = false;
            this.actualizagrillanotificaciones();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.loading = false;
        this.MostrarMensaje("Error", valido, false);
      }
    },
    async enviar (item) {
      if (await this.$refs.confirm.open("Confirmar Envío","Esta seguro de activar el envío de la notificación?")) {
        this.loading= true;
        const notificacion = JSON.stringify({idnotificacion: item.idnotificacion, usuario: this.usuario});
        axios.post("notificacion/PostEnviaNotificacion", notificacion, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevo = false;
            this.actualizagrillanotificaciones();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    async anular(item) {
      if (await this.$refs.confirm.open("Confirmar Anulación","Esta seguro de anular la notificación?")) {
        this.loading= true;
        const notificacion = JSON.stringify({idnotificacion: item.idnotificacion, usuario: this.usuario});
        axios.post("notificacion/PostAnulaNotificacion", notificacion, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevo = false;
            this.actualizagrillanotificaciones();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    modificardestinatarios () {
      this.loading=true;
      var filtro= JSON.stringify({fechadeudaal: this.edited.fechadeuda, nronotificacion: this.edited.nronotificacion, usuario: this.usuario});
      axios.post("Notificacion/PostListaPersonasDestinatarios", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.listapersonasdest = result.data.datos;
          this.dialogselectdestinatarios= true;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    async eliminardestinatarios () {
      if (await this.$refs.confirm.open("Confirmar","Esta seguro de querer quitar todos los destinatarios de la notificación?")) {
        this.edited.listadestinatarios=[];
      }
    },
    // vacialistadestinatarios () {
    //   this.edited.listadestinatarios= [];
    // },
    seleccionardestinatarios () {
      this.dialogselectdestinatarios=false;
    },
    async quitardestinatario (item) {
      if (await this.$refs.confirm.open("Confirmar","Esta seguro de querer quitar el destinatario de la notificación?")) {
        this.edited.listadestinatarios.splice(this.edited.listadestinatarios.indexOf(item), 1);
      }
    },
    listarpersonasdestinatarios () {
      this.loading=true;
      var filtro= JSON.stringify({fechadeudaal: this.fechaFormatoymd(new Date()),nronotificacion: this.edited.nronotificacion,   usuario: this.usuario});
      axios.post("Notificacion/PostListaPersonasDestinatarios", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.listapersonasdest = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    getColorConsulta(idestado) {
      if (idestado === 1) return "grey";
      else if (idestado === 2) return "green";
      else if (idestado === 3) return "orange";
      else if (idestado === 4) return "blue";
      else if (idestado === 5) return "red";
      else if (idestado === 6) return "black";
    },
    fechaFormatoymd(date) {
      return ( date.getFullYear() +"-" +((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate())
      );
    },
    horaFormatoymd(date) {
      return ((date.getHours().toString().length != 2 ? "0" + date.getHours().toString() : date.getHours().toString()) + ":"
      + (date.getMinutes().toString().length != 2 ? "0" + date.getMinutes().toString() : date.getMinutes().toString())
      //+ ":"+ (date.getSeconds().toString().length != 2 ? "0" + date.getSeconds().toString() : date.getSeconds().toString())
      );
    },
    verdestinatarios (item) {
      this.loading=true;
      var filtro= JSON.stringify({ idnotificacion: item.idnotificacion, usuario: this.usuario });
      axios.post("Notificacion/PostDestinatariosNotificacion", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.edited= {
            idnotificacion: item.idnotificacion, 
            fechaenvio: item.fechaenviostrymd,
            horaenvio: item.horaenviostrymd,
            listadestinatarios: result.data.datos,
            nronotificacion: item.nronotificacion,
            fechadeuda: item.fechadeudastrymd,
            titulo: item.tituloenvio,
            usuario: this.usuario
          };
          this.dialogverdestinatarios=true;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    verenvios (item) {
      this.loading=true;
      this.dialogverenviostitulo= 'Envíos de la Notificación ID ' + item.idnotificacion;
      var filtro= JSON.stringify({ idnotificacion: item.idnotificacion, usuario: this.usuario });
      axios.post("Notificacion/PostConsultaEnviosNotificacion", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.listaenviosnotificacion= result.data.datos;
          this.dialogverenvios=true;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    descargarpdfenvio (item) {
      window.open(item.urlwebpdfcorreo, '_blank')
    }
},
  computed: {
    fechaenviolocal: function () {
      if (this.edited.fechaenvio != null && this.edited.fechaenvio != "") {
        var fecha = new Date(this.edited.fechaenvio);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechadeudalocal: function () {
      if (this.edited.fechadeuda != null && this.edited.fechadeuda != "") {
        var fecha = new Date(this.edited.fechadeuda);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }
},
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.hide-toolbar .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
        display: none;
    }
}

.ql-font-roboto {
  font-family: 'Roboto', sans-serif;
}

.editor {
    height: 40rem;
    overflow: hidden;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa10 {
  width: 10%;
}
.ocupa20 {
  width: 20%;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>